"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAuthProxyAPI = void 0;
var constants_1 = require("./constants");
var api_1 = require("./types/api");
var app_1 = require("./types/app");
var utils_1 = require("./utils");
// todo [ ] create-react-app
//      [ ] обновлять авторизацию, если любая из ручек вернула 403
//          ??? хотя, возможно, это ответственность клиента
//      [ ] возможно, на первое время, стоит сделать какие-то дефолтные клиенты,
//          чтобы решить вопрос юзер-айди в заголовке startup
var createAuthProxyAPI = function createAuthProxyAPI(options) {
    var host = options.host, path = options.path, client = options.client, sourceID = options.sourceID, applicationDetectionRules = options.applicationDetectionRules;
    var urls = __assign(__assign({}, constants_1.authProxyUrls), options.urls);
    var headers = __assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, applicationDetectionRules);
    var apiPath = function (apiPath) { return host + "/" + path + "/" + apiPath; };
    var proxyPath = function (path) { return host + "/" + path; };
    var withSourceID = function (requestBody) { return sourceID
        ? (__assign({ sourceid: sourceID }, requestBody))
        : requestBody; };
    return function startAuthorization(options) {
        var onSuccess = options.onSuccess, _a = options.onError, onError = _a === void 0 ? utils_1.noop : _a;
        var timer;
        var userID;
        var token;
        var cancelAuthorization;
        var withHeaders = function (asyncHeaders) {
            var _a, _b;
            return (__assign(__assign(__assign(__assign({}, token && (_a = {},
                _a[api_1.ProxyApiHeader.TOKEN] = token,
                _a)), userID && (_b = {},
                _b[api_1.ProxyApiHeader.USER_ID] = userID,
                _b)), headers), asyncHeaders));
        };
        var withAsync = function (url, mergeOptions) {
            if (mergeOptions === void 0) { mergeOptions = {}; }
            var _a = mergeOptions.mergeBody, mergeBody = _a === void 0 ? withSourceID : _a, _b = mergeOptions.mergeHeaders, mergeHeaders = _b === void 0 ? withHeaders : _b;
            return function (asyncOptions) {
                if (asyncOptions === void 0) { asyncOptions = {}; }
                var headers = mergeHeaders(asyncOptions.headers);
                var body = mergeBody(asyncOptions.body);
                var method = asyncOptions.method || app_1.AsyncMethod.POST;
                return client({
                    url: url,
                    body: body,
                    method: method,
                    headers: headers,
                    onSuccess: asyncOptions.onSuccess,
                    onError: asyncOptions.onError,
                });
            };
        };
        var api = {
            __request: withAsync,
            estimate: withAsync(apiPath(urls.estimate), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { user: {
                        user_id: userID,
                    } })); },
            }),
            payments: withAsync(apiPath(urls.payments), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { user_id: userID })); },
            }),
            zoneInfo: withAsync(apiPath(urls.zoneInfo)),
            draft: withAsync(apiPath(urls.draft), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { parks: [], id: userID, callcenter: __assign(__assign({}, body === null || body === void 0 ? void 0 : body.callcenter), { key: sourceID }) })); },
            }),
            commit: withAsync(apiPath(urls.commit), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { userid: userID })); },
            }),
            suggest: withAsync(apiPath(urls.suggest), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { id: userID })); },
            }),
            preOrder: withAsync(apiPath(urls.preOrder)),
            // раньше на ручке search был поллинг, но он переехал в react-integration-api
            // тут же был тест на поллинг, если вдруг когда понадобится еще раз написать тест
            // то смотри коммит 27262685
            search: withAsync(apiPath(urls.search), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { user: {
                        user_id: userID,
                    } })); },
            }),
            cancel: withAsync(apiPath(urls.cancel), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { userid: userID })); },
            }),
            couponActivate: withAsync(apiPath(urls.couponActivate), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { id: userID })); },
            }),
            couponDeactivate: withAsync(apiPath(urls.couponDeactivate), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { id: userID })); },
            }),
            couponList: withAsync(apiPath(urls.couponList), {
                mergeBody: function (body) { return withSourceID(__assign(__assign({}, body), { id: userID })); },
            }),
            localitySuggest: withAsync(proxyPath(urls.localitySuggest)),
            historyList: withAsync(proxyPath(urls.historyList)),
            historyItem: withAsync(proxyPath(urls.historyItem)),
            receipts: withAsync(proxyPath(urls.receipts), {
                method: app_1.AsyncMethod.GET
            }),
            // fixme never на всех ручках специально, чтобы знать что не покрыто типами
            tariffDescription: withAsync(apiPath(urls.tariffDescription)),
            changeDestinations: withAsync(apiPath(urls.changeDestinations)),
            /** @deprecated use suggest instead (action=pin_drop) */
            nearestZone: withAsync(apiPath(urls.nearestZone)),
            /** @deprecated use suggest instead */
            geoSearch: withAsync(apiPath(urls.geoSearch)),
            /** @deprecated use suggest instead (action=pin_drop, type=a|b) */
            nearestPosition: withAsync(apiPath(urls.nearestPosition)),
            /** @deprecated use suggest instead (action=zero_suggest, type=a) */
            expectedPositions: withAsync(apiPath(urls.expectedPositions)),
            /** @deprecated use suggest instead (action=zero_suggest, type=b) */
            expectedDestinations: withAsync(apiPath(urls.expectedDestinations))
        };
        // авторизация на коленке, пока что это единственный известный мне способ авторизации
        var tokenRequest = withAsync(proxyPath(urls.token), { mergeBody: utils_1.noop });
        var startupRequest = withAsync(proxyPath(urls.startup));
        var authRequest = function () {
            timer = undefined;
            // вдруг понадобится отменить авторизацию
            cancelAuthorization = tokenRequest({
                onError: onError,
                onSuccess: function (tokenResponse) {
                    token = tokenResponse.sk;
                    // тоже самое
                    cancelAuthorization = startupRequest({
                        onError: onError,
                        onSuccess: function (startupResponse, startupHeaders) {
                            // не знаю на сколько это хорошо, но пока так, возможно стоит добавить process.env.NODE_ENV
                            if (!(startupHeaders === null || startupHeaders === void 0 ? void 0 : startupHeaders[api_1.ProxyApiHeader.USER_ID])) {
                                throw new Error('todo: startup did not return user');
                            }
                            var maxAge = tokenResponse['max-age-seconds'] * 1000;
                            cancelAuthorization = undefined;
                            // обновим токен и юзера когда останется меньше 20% времени
                            // обновить юзера тоже нужно, потому что есть шанс что пользователь в другой вкладке сменил авторизацию
                            timer = maxAge > 0
                                ? setTimeout(authRequest, maxAge - maxAge * 0.2)
                                : undefined;
                            if (userID !== startupHeaders[api_1.ProxyApiHeader.USER_ID]) {
                                userID = startupHeaders[api_1.ProxyApiHeader.USER_ID];
                                onSuccess(api, startupResponse, startupHeaders);
                            }
                        },
                    });
                },
            });
        };
        // авторизуемся
        authRequest();
        return function stopAuthorization() {
            timer && clearTimeout(timer);
            cancelAuthorization && cancelAuthorization();
        };
    };
};
exports.createAuthProxyAPI = createAuthProxyAPI;
